import React, { useEffect } from 'react';
import iconPrimary from '../assets/brand/icon-transparent.svg';

/**
 * Renders the OG cover at exactly 1200x630 with no chrome.
 * Visit /og-render then capture full-page screenshot at viewport 1200x630.
 */
const OGCoverRender = () => {
  useEffect(() => {
    document.body.style.margin = '0';
    document.body.style.padding = '0';
    document.body.style.background = '#F0EBE2';
    document.documentElement.style.margin = '0';
    document.documentElement.style.padding = '0';
  }, []);

  return (
    <div
      style={{
        width: 1200,
        height: 630,
        backgroundColor: '#F0EBE2',
        position: 'relative',
        overflow: 'hidden',
        fontFamily: "'Cormorant Garamond', serif"
      }}
      data-testid="og-cover-render"
    >
      {/* Right vertical terracotta accent band */}
      <div
        style={{
          position: 'absolute',
          right: 0,
          top: 0,
          width: 8,
          height: 630,
          backgroundColor: '#D4820A'
        }}
      />

      {/* Eyebrow tracker */}
      <div
        style={{
          position: 'absolute',
          left: 80,
          top: 80,
          fontFamily: "'Work Sans', sans-serif",
          fontSize: 18,
          fontWeight: 600,
          letterSpacing: '0.25em',
          color: '#D4820A',
          textTransform: 'uppercase'
        }}
      >
        India&rsquo;s Cultural Sector Hiring Platform
      </div>

      {/* Headline */}
      <h1
        style={{
          position: 'absolute',
          left: 80,
          top: 138,
          margin: 0,
          fontFamily: "'Playfair Display', serif",
          fontSize: 86,
          fontWeight: 500,
          letterSpacing: '-0.01em',
          lineHeight: 1.05,
          color: '#0F2942',
          maxWidth: 980
        }}
      >
        The career you want
        <br />
        in the industry you{' '}
        <em
          style={{
            color: '#D4820A',
            fontStyle: 'italic',
            fontWeight: 500
          }}
        >
          love.
        </em>
      </h1>

      {/* Subhead */}
      <p
        style={{
          position: 'absolute',
          left: 80,
          top: 380,
          margin: 0,
          fontFamily: "'Cormorant Garamond', serif",
          fontSize: 30,
          fontWeight: 400,
          color: '#0F2942',
          lineHeight: 1.35,
          maxWidth: 980
        }}
      >
        Curated jobs, gigs, residencies, grants and open calls
        <br />
        across India&rsquo;s arts, culture and creative industries.
      </p>

      {/* Logo lockup (icon + wordmark) bottom-left */}
      <div
        style={{
          position: 'absolute',
          left: 80,
          bottom: 60,
          display: 'flex',
          alignItems: 'center',
          gap: 18
        }}
      >
        <img
          src={iconPrimary}
          alt=""
          aria-hidden="true"
          width={72}
          height={68}
          style={{ display: 'block' }}
        />
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            lineHeight: 1
          }}
        >
          <span
            style={{
              fontFamily: "'Cormorant Garamond', serif",
              fontSize: 42,
              fontWeight: 500,
              color: '#0F2942',
              letterSpacing: '-0.01em'
            }}
          >
            Culture
          </span>
          <span
            style={{
              fontFamily: "'Cormorant Garamond', serif",
              fontSize: 42,
              fontWeight: 500,
              color: '#D4820A',
              letterSpacing: '-0.01em',
              marginTop: 2
            }}
          >
            Careers
          </span>
        </div>
      </div>

      {/* URL bottom-right */}
      <div
        style={{
          position: 'absolute',
          right: 96,
          bottom: 70,
          fontFamily: "'Work Sans', sans-serif",
          fontSize: 18,
          fontWeight: 500,
          letterSpacing: '0.05em',
          color: '#D4820A'
        }}
      >
        culturecareers.org
      </div>
    </div>
  );
};

export default OGCoverRender;
